import React, { useState, useEffect } from "react";
import { onecodeAPI } from "../AppConfig";
import ApplicationStatusBody from "../Components/ApplicationStatusBody";
import brandIcon from "./HdfcLogo.png";
import "./Hdfc.css";

export default function HdfcForm() {
  const [loading, setLoading] = useState(true);
  const [applicationStatus, setApplicationStatus] = useState(
          {icon: "loading",
          reason: "Please wait while we set things up for you.This might take upto 30 seconds.",
          status: "Generating Application Link.."}
        );
  const [customer,setCustomer] = useState(null);

  useEffect(() => {
    try {
      let params = new URLSearchParams(window.location.search);
      let hash = encodeURIComponent(params.get("hash"));
      if (params.get("hash")) {
        getEligibility(hash);
        getCustomerExistingDetails(hash);
      }
    } catch (error) {
      console.log(error);
    }
   }, []);

    const getCustomerExistingDetails = async (hash) => {
        try {
        setLoading(true);
        const res = await onecodeAPI.post(`/public/customer/findByHash`, {
          hash: hash,
        });
        setCustomer(res.data);
        setLoading(false);
        } catch (error) {
        setLoading(false);
        console.log("errror-customer", error);
        }
    };
  
    const getEligibility = async (hash) => {
        setLoading(true);
        try {
        const submit = await onecodeAPI.post(`/public/hdfcDsaLead/submit`,{},{
          headers:{
              hash: hash,
          }
        });
        setApplicationStatus(submit.data.data)
        setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("errror-customer", error);
    }
  };

  return (
    <div className="HdfcPage">
        <div className="ImageDiv" >
        <img
        src={brandIcon}
        className="Image"
        />
        </div>
        <p className="CustomerDetails">
        Credit Card Application for {customer?.fullName}, {customer?.phoneNumber}
        </p>
        <div className="ApplicationStatus"> 
        <ApplicationStatusBody applicationStatus={applicationStatus}/>
        </div>
    </div>
  );

}
